import { RouteRecordRaw } from "vue-router";
import Exception400 from "./400.vue";
import Exception404 from "./404.vue";

export const EXCEPTION_ROUTES: Array<RouteRecordRaw> = [{
  path: "/:pathMatch(.*)",
  name: '404',
  meta: { title: '页面不存在' },
  component: Exception404
}, {
  path: "/400",
  name: '400',
  meta: { title: '请求出错' },
  component: Exception400
}];